import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/email-confirm', component: () => import('@/views/emailConfirm/index'), hidden: true },
  { path: '/register', component: () => import('@/views/register/index'), hidden: true },
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/forgot-password', component: () => import('@/views/forgotPassword/index'), hidden: true },
  { path: '/reset-password', component: () => import('@/views/resetPassword/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true }
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    name: 'Dashboard',
    // meta: { title: 'Dashboard' },
    children: [{
      path: '',
      component: () => import('@/views/dashboard/index'),
      meta: { title: 'Dashboard', icon: 'dashboard' }
    }]
  },
  {
    path: '/trackings',
    component: Layout,
    meta: { roles: ['Superadmin', 'Admin', 'User'] },
    children: [{
      path: '',
      name: 'Tracking',
      component: () => import('@/views/tracking/index'),
      meta: { title: 'Tracking', icon: 'list', roles: ['Superadmin', 'Admin', 'User'] }
    }]
  },
  {
    path: '/delivery-orders',
    component: Layout,
    meta: { roles: ['Superadmin', 'Admin'] },
    children: [{
      path: '',
      name: 'Delivery Order',
      component: () => import('@/views/deliveryOrder/index'),
      meta: { title: 'Delivery Order', icon: 'table', roles: ['Superadmin', 'Admin'] }
    }, {
      path: ':delivery_order_id(\\d+)/trackings',
      name: 'Delivery Order',
      component: () => import('@/views/tracking/index'),
      meta: { title: 'Delivery Order', icon: 'table', noCache: true },
      hidden: true
    }]
  },
  {
    path: '/couriers',
    component: Layout,
    meta: { roles: ['Superadmin'] },
    children: [{
      path: '',
      name: 'Courier',
      component: () => import('@/views/courier/index'),
      meta: { title: 'Courier', icon: 'guide', roles: ['Superadmin'] }
    }]
  },
  {
    path: '/users',
    component: Layout,
    meta: { roles: ['Superadmin'] },
    children: [{
      path: '',
      name: 'Users',
      component: () => import('@/views/user/index'),
      meta: { title: 'Users', icon: 'user', roles: ['Superadmin'] }
    }]
  },
  {
    path: '/change-password',
    component: Layout,
    hidden: true,
    meta: { },
    children: [{
      path: '',
      name: 'Change Password',
      component: () => import('@/views/changePassword/index'),
      meta: { title: 'Change Password', icon: 'form' }
    }]
  },
  { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js